import Backend from 'App/Dataman-Backend';

export class ApiError extends Error {
  constructor(message, response, ...rest) {
    super(message);
    this.response = response;
    this.extra = rest;
  }
}

export async function apiGet(url, params = {}) {
  return Backend.get({ url, ...params });
}

export async function apiPost(url, params = {}) {
  return Backend.post({ url, ...params });
}

export async function apiPostJSON(url, data, params = {}) {
  return Backend.postJSON(data, { url, ...params });
}

export async function apiPut(url, params = {}) {
  return Backend.put({ url, ...params });
}

export async function apiDelete(url, params = {}) {
  return Backend.delete({ url, ...params });
}

export async function apiPatch(url, params = {}) {
  if (!params.headers) {
    params.headers = {};
  }
  if (!params.headers['content-type']) {
    params.headers['content-type'] = 'application/merge-patch+json';
  }
  return Backend.patch({ url, ...params });
}

// noinspection JSValidateJSDoc
/**
 * @param {string} url
 * @returns {{
 *    getList: (function(*): Promise<AxiosResponse<any>>),
 *    getItem: (function(*): Promise<AxiosResponse<any>>),
 *    create: (function(*): Promise<AxiosResponse<any>>),
 *    update: (function(*): Promise<AxiosResponse<any>>),
 *    remove: (function(*): Promise<AxiosResponse<any>>),
 * }}
 */
export function makeRequestsDict(url) {
  return {
    getList: (params, conf) => apiGet(url, { ...conf, params, ld: true, is_protected: true }),
    getItem: (id) => apiGet(`${url}/${id}`, { is_protected: true }),
    create: (data, composite = false) => {
      const buildUrl = composite ? `${url}/composite` : url;
      return apiPost(buildUrl, { data, is_protected: true });
    },
    update: (id, data) => apiPut(`${url}/${id}`, { data, is_protected: true }),
    remove: (id) => apiDelete(`${url}/${id}`, { is_protected: true }),
  };
}
